export default function initializeWooFilters() {
    new WooFilters();
}

class WooFilters {

    constructor() {
        if(!this.setVariables()) return;
        this.hideActiveFilters();
        this.addFilterButtons();
        this.addTitleSelectedFilters();
    }

    setVariables() {
        this.filterBar = document.querySelector('.filter-bar');
        if(!this.filterBar) return false;
        this.filterItems = this.filterBar.querySelectorAll('.wpfFilterWrapper');
        if(!this.filterItems) return false;

        return true;
    }


    // domyślnie wybrane filtry są rozwinięte po załadowaniu strony - ukrywamy je
    hideActiveFilters() {
        this.filterBar.querySelectorAll('.wpfFilterWrapper:not(.wpfNotActive)').forEach(function (wrapperEl) {
            let filterContent = wrapperEl.querySelector('.wpfFilterContent');
            filterContent.classList.add('wpfBlockAnimated');
            filterContent.classList.add('wpfHide');

            let filterToggle = wrapperEl.querySelector('.wpfTitleToggle');
            filterToggle.classList.remove('fa-chevron-up');
            filterToggle.classList.add('fa-chevron-down');

        });
    }

    // tworzy przyciski "Zapisz filtry" pod każdym filtrem
    addFilterButtons() {
        let filterButton = this.filterBar.querySelector('.wpfFilterButton');
        let dynamicButton = document.createElement('button');
        dynamicButton.classList.add('button');
        dynamicButton.classList.add('customFilterButton');
        dynamicButton.innerText = filterButton.innerText;

        this.filterItems.forEach(function (wrapperEl) {
            let button = dynamicButton.cloneNode(true);
            button.addEventListener('click', function (e) {
                var mouseDownEvent = new MouseEvent('mousedown', {
                    bubbles: true,
                    cancelable: true,
                    button: 0 // LPM
                });
                filterButton.dispatchEvent(mouseDownEvent);

            });
            wrapperEl.querySelector('.wpfFilterContent').appendChild(button);
        }.bind(this));
    }

    // zaznaczone filtry są dodawane do tytułu filtra
    addTitleSelectedFilters() {
        //obserwujemy zmiany w selectedFilters z pomocą Observera i jeśli cokolwiek w tym div się zmieni to szukamy w this.filterItems tego samego filtra i aktualizujemy jego tytuł
        let observer = new MutationObserver(function(mutations) {
            this.refreshFilterTitles();
        }.bind(this));
        observer.observe(this.filterBar.querySelector('.wpfSelectedParameters'), { childList: true });



    }

    refreshFilterTitles() {
        let selectedFilters = this.filterBar.querySelectorAll('.wpfSelectedParameter');
        let selectedFilterCounts = {};
        selectedFilters.forEach(function (selectedFilter) {
           let filterType = selectedFilter.dataset.filterType;
           if(filterType === 'wpfAttribute') {
                let filterName = selectedFilter.dataset.filterName;
                if(!selectedFilterCounts[filterName]) {
                     selectedFilterCounts[filterName] = 0;
                }
                selectedFilterCounts[filterName]++;
           }
        }.bind(this));
        this.filterItems.forEach(function (wrapperEl) {
            let filterTitle = wrapperEl.querySelector('.wpfFilterTitle .wfpTitle');
            let filterName = wrapperEl.dataset.getAttribute;
            if(selectedFilterCounts[filterName]) {
                let spanFiltersCount = '<span class="customTitleCount">'+selectedFilterCounts[filterName]+'</span>';
                filterTitle.innerHTML = wrapperEl.dataset.title + spanFiltersCount;
            } else {
                filterTitle.innerText = wrapperEl.dataset.title;
            }
        }.bind(this));
    }
}
